import { FC, useState } from "react";
import { TablePageHeader } from "@components/pageHeader/TablePageHeader";
import { PersonalViewFilters } from "../types";
import { WorkspacesView } from "./WorkspacesView";

export const WorkspacesPage: FC = () => {
    const [filters, setFilters] = useState<PersonalViewFilters>({
        search: "",
    });

    return (
        <section>
            <TablePageHeader
                search={filters.search}
                onSearchChange={(val) =>
                    setFilters((currentFilters) => ({
                        ...currentFilters,
                        search: val,
                    }))
                }
                filters={filters}
                onFiltersChange={(newFilters) => {
                    setFilters((currentFilters) => ({
                        ...currentFilters,
                        ...newFilters,
                    }));
                }}
                isFullPage
            />
            <WorkspacesView
                search={filters.search}
                setSearch={(search) =>
                    setFilters((currentFilters) => ({
                        ...currentFilters,
                        search,
                    }))
                }
            />
        </section>
    );
};
